/** production environment */
exports.production = {
  DAKTELA_GUI_TOKEN_CZ: 'pr2o4p851469orr6o7rq74r0o26946s9',
  DAKTELA_GUI_TOKEN_PL: '9s25n52n0prn82nrr96q1ppssor1r88n',
}
